import { render } from "./side-menu.html?vue&type=template&id=0b723c9e&scoped=true&ts=true&external"
import script from "./side-menu.ts?vue&type=script&lang=ts&external"
export * from "./side-menu.ts?vue&type=script&lang=ts&external"

import "./side-menu.scss?vue&type=style&index=0&id=0b723c9e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b723c9e"]])

export default __exports__